import { useGetCategoriesQuery, useGetFamiliesQuery, useGetVariantsQuery } from '../app/api-slice';
import { useDataRequestLang } from '../app/main-slice';

export function useCategoryName(categoryId: string) {

    const lang = useDataRequestLang();
    const { data: categories = [] } = useGetCategoriesQuery(lang);
    
    const category = categories.find(c => c.id === categoryId);
    return category?.name ?? '';

}

export function useFamilyName(categoryId: string, familyId: string) {

    const lang = useDataRequestLang();
    const { data: families = [] } = useGetFamiliesQuery({
        lang,
        category: categoryId
    });

    const family = families.find(f => f.id === familyId);
    return family?.name ?? '';

}

export function useVariantName(familyId: string, variantId: string) {

    const lang = useDataRequestLang();
    const { data: variants } = useGetVariantsQuery({
        lang,
        family: familyId
    });

    if(variants) {
        const option = variants.options.find(o => o.id);
        return option?.title ?? '';
    } else {
        return '';
    }
    

}